import { Component, inject } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ImageGeneratorComponent } from '@components/image-generator/image-generator.component';
import { bottomNavigationProfileSP } from '@shared/helper/responsive-sizes';
import { TokenService } from '@shared/services/token.service';

@Component({
  selector: 'app-bottom-navigation',
  imports: [MatIconModule, MatRippleModule, ImageGeneratorComponent, RouterLink, RouterLinkActive],
  templateUrl: './bottom-navigation.component.html',
  styleUrl: './bottom-navigation.component.scss',
})
export class BottomNavigationComponent {
  profileSizes = bottomNavigationProfileSP;

  tokenService = inject(TokenService);
}
